var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-5",attrs:{"elevation":"0"}},[_c('h2',[_vm._v(_vm._s(_vm.$store.getters.t('대역폭 (Bandwidth)')))]),_c('div',{ref:"liveBandwidthChart",staticStyle:{"width":"100%","height":"400px"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }